module.exports = __webpack_public_path__ + "img/lens-160-plus-02.f0b84424.png";